import React from 'react';
import classes from './BoxInfo.module.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const BoxInfo = (props) => {
  return (
    <div className={classes.BoxStepInfoContainer}>
      <CheckCircleIcon style={{ color: '#646464' }} />
      <div className={classes.TextoInfo}>{props.children}</div>
    </div>
  );
};
export default BoxInfo;